import Vue from 'vue'

Vue.mixin({
  methods: {
    isSmallScreen() {
      let small = false
      if (this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
        small = true
      }
      return small
    },
  },
})
